export const modalSx = {
  '.MuiDialog-paper': {
    width: '746px',
    padding: '40px 72px 48px 72px',
  },
};

export const modalTitleSx = { margin: 0, padding: '40px 0 30px 0' };
